/// <reference path="../../../typings/browser.d.ts" />
/// <reference path="../../../customtypings/parsley/parsley.d.ts" />

namespace Application.Controllers {
    'use strict';

    import IConnectionRoomGroup = Models.IConnectionRoomGroup;
    import ConnectionRoomGroup = Models.ConnectionRoomGroup;

    export interface IConnectionRoomGroupModalScope extends ng.IScope {
        init: () => void;
        modalClose: () => void;
        modalSave: () => void;
        connectionRoomGroups: ConnectionRoomGroup[];
        connectionRoomId: number;
        connectionRoomGroup: IConnectionRoomGroup;
        max_blocks: number;
        blocks: Models.IBlockComplete[];
        blocksSearch: {
            name: string;
        };
        selectedBlocks: Models.IBlockComplete[];
        selectedBlocksSearch: {
            name: string;
        };

        select: (block: Models.IBlockComplete) => void;
        unselect: (block: Models.IBlockComplete) => void;
        selectAll: () => void;
        unselectAll: () => void;
    }

    /**
     * ConnectionRoomGroupController class
     */
    export class ConnectionRoomGroupModalController {
        public static templateUrl: string = "decorators/modals/connection-room-group-modal.html";
        public static ID: string = "#id-connection-room-group-modal";
        public static $name: string = "groupModalController";
        public static $inject: string[] = ['$scope',
          'close',
          'connectionRoomGroup',
          'blocks',
          'connectionRoomId',
          'connectionRoomGroups',
           'blockService',
          '$timeout'
        ];
        private static PARSLEY_CHECK_VALIDATE: string = 'validateName';
        public static  MAX_BLOCKS: number = 2;

        /**
         * Constructor of the class.
         */
        constructor(private $scope: IConnectionRoomGroupModalScope,
                    private close: (connectionRoomGroup: IConnectionRoomGroup) => void,
                    connectionRoomGroup: ConnectionRoomGroup,
                    blocks: Models.IBlockComplete[],
                    connectionRoomId: number,
                    connectionRoomGroups: ConnectionRoomGroup[],
                    protected blockService: Services.BlockService,
                    private $timeout: ng.ITimeoutService

        ) {
            this.addParsleyValidateName();

            $timeout(() => {
                window.altair_forms_validation();
            }, 500);

            this.$scope.init = async () => {
                this.$scope.connectionRoomGroup = connectionRoomGroup;
                this.$scope.connectionRoomId = connectionRoomId;
                this.$scope.connectionRoomGroups = connectionRoomGroups;
                this.$scope.max_blocks = ConnectionRoomGroupModalController.MAX_BLOCKS;
                this.$scope.blocks = blocks.filter((block) =>{
                    return !this.$scope.connectionRoomGroup.connectionRoomGroupBlocks.some((id)=>{return id==block.id});
                });
                this.$scope.selectedBlocks = blocks.filter((block) =>{
                    return this.$scope.connectionRoomGroup.connectionRoomGroupBlocks.some((id)=>{return id==block.id});
                });

                this.addBlocksRemovedFromRoom();
            };

            this.$scope.select = (block: Models.IBlockComplete): void => {
                if (this.$scope.selectedBlocks.length < ConnectionRoomGroupModalController.MAX_BLOCKS) {
                    ConnectionRoomGroupModalController.removeBlock(this.$scope.blocks, block);
                    this.$scope.selectedBlocks.push(block);
                }
            };

            this.$scope.unselect = (block: Models.IBlockComplete): void => {
                // if the href is empty the block has been removed from the room
                if (block.href != "") {
                    this.$scope.blocks.push(block);
                }
                ConnectionRoomGroupModalController.removeBlock(this.$scope.selectedBlocks, block);
            };

            this.$scope.selectAll = () => {
                let filterString: string = this.$scope.blocksSearch ? this.$scope.blocksSearch.name.toLowerCase() : '';
                this.$scope.blocks.filter((block: Models.IBlockComplete) => {
                    return block.name.toLowerCase().indexOf(filterString) !== -1;
                }).forEach((block: Models.IBlockComplete) => {
                    this.$scope.select(block);
                });
            };

            this.$scope.unselectAll = () => {
                let filterString: string = this.$scope.selectedBlocksSearch ? this.$scope.selectedBlocksSearch.name.toLowerCase() : '';
                this.$scope.selectedBlocks.filter((block: Models.IBlockComplete) => {
                    return block.name.toLowerCase().indexOf(filterString) !== -1;
                }).forEach((block: Models.IBlockComplete) => {
                    this.$scope.unselect(block);
                });
            };

            this.$scope.modalClose = (): void => {
                this.close(undefined);
            };

            this.$scope.modalSave = () => {
                if(this.validateForm()) {
                    this.updateConnectionRoomGroupBlocksAndClose();
                }
            }

            this.$scope.$on('$destroy', () => {
                window.Parsley.removeValidator(ConnectionRoomGroupModalController.PARSLEY_CHECK_VALIDATE);
            });

            this.$scope.init();
        }

        private addBlocksRemovedFromRoom() {
            let removedBlockIds = this.$scope.connectionRoomGroup.connectionRoomGroupBlocks.filter((blockId) => {
                return !this.$scope.selectedBlocks.some((block) => {return blockId == block.id;});
            });

            for (const removedBlockId of removedBlockIds) {
                this.blockService.findById(removedBlockId).then((removedBlock) => {
                      removedBlock.href = "";
                      removedBlock.name += " (Removed from room)";
                      this.$scope.selectedBlocks.push(removedBlock);
                  }
                );
            }
        }

        private addParsleyValidateName(): void {
            window.Parsley
              .addValidator(ConnectionRoomGroupModalController.PARSLEY_CHECK_VALIDATE, {
                  validateString: (value: string): boolean => {
                      return this.validateName(value);
                  },
                  messages: {
                      en: 'The name already exists',
                  },
              });
        }

        private validateForm() {
            let hasName = this.$scope.connectionRoomGroup.name !== undefined && this.$scope.connectionRoomGroup.name !== "";
            let isValidName: boolean;
            if(hasName) {
                isValidName = this.validateName(this.$scope.connectionRoomGroup.name);
            } else {
                isValidName = false;
            }

            return isValidName;
        }

        private validateName(name: String) {
            return name.length > 0 && name.length < 256 && !this.$scope.connectionRoomGroups.some((connectionRoomGroup)=>{return (this.$scope.connectionRoomGroup && this.$scope.connectionRoomGroup.id != connectionRoomGroup.id) &&  name===connectionRoomGroup.name});
        }

        private updateConnectionRoomGroupBlocksAndClose() {
            this.$scope.connectionRoomGroup.connectionRoomId = this.$scope.connectionRoomId;
            this.$scope.connectionRoomGroup.connectionRoomGroupBlocks = this.$scope.selectedBlocks.map((block) => {
                return block.id;
            });
            this.close(this.$scope.connectionRoomGroup);
        }

        private static removeBlock(blocks: Models.IBlockComplete[], block: Models.IBlockComplete): void {
            let indexFound: number = -1;
            for (let i: number = 0; i < blocks.length ; i++) {
                if (blocks[i].id === block.id)
                    indexFound = i;
            }
            if (indexFound > -1) {
                blocks.splice(indexFound, 1);
            }
        }
    }
}
